import { ErrorResponse, GlobalVariableValues, MessageParameters } from '@gtpl/shared-models/common-models';
import { AllIndentReportResponse, AllIndentsResponseModel, GetHarvestingResponseModel, GrnCompletedStatusResponse, GrnStatusUpdate, HarvestingModelDto, HarvestModel, HarvestReportResponse, IndentAckResponse, IndentDropdownModel, IndentDropdownResponse, IndentModel, IndentQtyModel, IndentQtyResponse, IndentQuantityRequest, IndentResponse, IndentResponseModel, RmIndentReportDto } from '@gtpl/shared-models/raw-material-procurement';
import { Injectable } from '@nestjs/common';
import { Cron } from '@nestjs/schedule';
import { InjectRepository } from '@nestjs/typeorm';
import { getManager, Like, Raw, Repository, TransactionManager } from 'typeorm';
import { IndentDto } from './dto/indent.dto';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { Indent } from './indent.entity';
import { EmployeeService, ProductService, SuppliersService, VehicleService } from '@gtpl/shared-services/masters';
import { CommonResponse, EmployeeResponseModel, MasterInfoFromIndentRequest, MasterInfoFromIndentResponse, SupplierFarmResponse, VehicleResponseModel } from '@gtpl/shared-models/masters';
import { UpdateVehicleStatusRequest } from './dto/update-vehicle-status.request';
import { IndentIdRequest } from './dto/indent-id.request';
import { PlantRequest } from './dto/plant.request';
import { VehicleAssignmentService } from '@gtpl/shared-services/transportation';
import { RawMaterialGrnService } from '../raw-material-grn/raw-material-grn.service';
import { IndentReportRequest } from './dto/indent-request';
import { HarvestDto } from './dto/harvest.dto';
import { HaverstReport } from './harvest-report.entity';
import { HarvestIdRequest } from './dto/harvest-id.request';
import { IndentDetailsDto } from './dto/indent-details.dto';
import { IndentItems } from './indent-items.entity';
import appSettings from 'apps/services/config';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { IndentAbstractRequest } from './dto/indent-abstract';
import whatsApp from 'apps/services/whatsapp';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
const mastersSuppluierTable = appSettings.masters_db + '.suppliers';
const mastersFarmsTable = appSettings.masters_db + '.farms';
const mastersProductsTable = appSettings.masters_db + '.products';
const mastersEmployeeTable = appSettings.masters_db + '.employee_details';
const rmIndentTable = appSettings.rm_procure_db + '.indent';
const rmGrnTable = appSettings.rm_procure_db + '.grn';
const rmGrnItemsTable = appSettings.rm_procure_db + '.grn_items';
const rmIndentItemsTable = appSettings.rm_procure_db + '.indent_items';
const masterUnit = appSettings.masters_db +'.unitcodes';
let moment = require('moment');

import {  WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast'
import { WhatsAppLogDto } from '@gtpl/shared-models/whatsapp-broad-cast';

@Injectable()
export class IndentService {
    constructor(
        private logService: LogsService,

        @InjectRepository(Indent) private repository: Repository<Indent>,
        @InjectRepository(HaverstReport) private harvestEntity: Repository<HaverstReport>,
        @InjectRepository(IndentItems) private indentItems: Repository<IndentItems>,
        private supplierService: SuppliersService,
        private vehicleAssignmentService: VehicleAssignmentService,
        private employeeService: EmployeeService,
        private vehicleService: VehicleService,
        private productRepository: ProductService,
        private wpService: WhatsAppNotificationService,
        private wtsAppBroadCatService : WhatsappBroadCastService,


    ) { }

    /**
     * validate all the master related fields like farmer,farmercode,product,employee
     * @param indentDto 
     * @returns 
     */
    async validateAllMasterIdsExist(indentDto: IndentDto): Promise<boolean> {
        await this.supplierService.getMastersRelatedDataFromIndent(new MasterInfoFromIndentRequest(indentDto.farmer, indentDto.farmerCode, indentDto.product, indentDto.assignLead1, indentDto.assignLead2));
        return true;
    }
    /**
     * Service to create new indent
     * @param indentDto 
     * @returns 
     */
    async createIndent(indentDto: IndentDetailsDto): Promise<IndentResponseModel> {
        // await this.validateAllMasterIdsExist(indentDto);
        // getting count of indents for the month from 1 date to current date
        const manager = new GenericTransactionManager();
        try {
            let today = new Date();
            let CurrentYear = today.getFullYear();
            let CurrentMonth = today.getMonth();
            let toDate = 0;
            if (CurrentMonth+1 < 4) {
                toDate = (CurrentYear);
            } else {
                toDate = (CurrentYear + 1);
            }

            const date = new Date();
            const currentMonth = date.getMonth() + 1;
            const monthsObj = { 1: 'A', 2: 'B', 3: 'C', 4: 'D', 5: 'E', 6: 'F', 7: 'G', 8: 'H', 9: 'I', 10: 'J', 11: 'K', 12: 'L' }
            const monthEqualAlphabet = monthsObj[date.getMonth() + 1];
            const startDate = '"' + date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + 1 + '"';
            const endDate = '"' + date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + '"';
            const indentCount = await this.repository.createQueryBuilder('indent')
                .where('Date(created_at) between ' + startDate.toString() + ' and ' + endDate.toString())
                .getCount();
            // creating new indent serial number
            const indentSerialNo = (indentCount.toString().length > 3) ? indentCount + 1 : ('0000' + (indentCount + 1)).slice(-4);
            // creating new indent code
            const indentCode = 'I' + toDate.toString().substr(-2) + '/' + monthEqualAlphabet + date.getDate() + '/' + indentSerialNo;
            const indentEntity = new Indent();
            if (indentDto.indentId > 0) {
                indentEntity.indentId = indentDto.indentId;
                indentEntity.updatedUser = indentDto.updatedUser;
            }
            if (!(indentDto.indentId > 0)) {
                indentEntity.indentCode = indentCode;
            }
            indentEntity.indentDate = indentDto.indentDate;
            indentEntity.plantId = indentDto.plantId;
            indentEntity.harvestingDate = indentDto.harvestingDate;
            indentEntity.harvestingTime = indentDto.harvestingTime;
            indentEntity.supplierType = indentDto.supplierType;
            indentEntity.createdUser = indentDto.createdUser;
            indentEntity.assignLead1 = indentDto.assignLead1;
            indentEntity.assignLead2 = indentDto.assignLead2;
            indentEntity.indentBy = indentDto.indentBy;
            indentEntity.isVehicleRequired = indentDto.isVehicleRequired;
            indentEntity.harvestType = indentDto.harvestType;
            indentEntity.commission = indentDto.commission;
            indentEntity.commissionType = indentDto.commissionType;
            indentEntity.grnCompleted = indentDto.grnCompleted;
            indentEntity.isActive = indentDto.isActive == undefined ? true : indentDto.isActive;
            const indentItems = []
            for (const item of indentDto.indentItems) {
                let indentItemObj = new IndentItems();
                if (item.broker) {
                    indentItemObj.broker = item.broker;
                }
                if (item.indentItemId > 0) {
                    indentItemObj.indentItemId = item.indentItemId;
                    indentItemObj.indentInfo = new Indent();
                    indentItemObj.indentInfo.indentId = item.indentId;
                    // indentItemObj.updatedUser = item.updatedUser;
                }
                indentItemObj.expectedCount = item.expectedCount;
                indentItemObj.expectedPrice = item.expectedPrice;
                indentItemObj.expectedCount2 = item.expectedCount2;
                indentItemObj.expectedPrice2 = item.expectedPrice2;
                indentItemObj.expectedCount3 = item.expectedCount3;
                indentItemObj.expectedPrice3 = item.expectedPrice3;
                indentItemObj.expectedQty = item.expectedQty;
                indentItemObj.farmer = item.farmer;
                indentItemObj.farmerCode = item.farmerCode;
                indentItemObj.product = item.product;
                indentItems.push(indentItemObj);

            }
            indentEntity.indentItemsInfo = indentItems;
            manager.startTransaction();
            const indentResponse = await this.repository.save(indentEntity);
            if (indentResponse) {
                manager.completeTransaction()
                const data = new IndentResponseModel(true, 10000, 'Indent Created Successfully');
                // const newLogDto = new LogsDto(1,'Indent Created', 'IndentItems', 0, true, 'Indent Created Successfully','','',"")
                // let res = await this.logService.createLog(newLogDto);
                // console.log(res);
                return data
            } else {
                manager.releaseTransaction();
            }
        } catch (err) {
            manager.releaseTransaction();
            return new IndentResponseModel(false, 10000, err);

        }
    }

    // /**
    //  * Service to update a indent details
    //  * @param indentDto 
    //  * @returns 
    //  */
    // async updateIndent(indentDto: IndentDto): Promise<IndentAckResponse> {
    //     await this.validateAllMasterIdsExist(indentDto);
    //     const indentEntity = await this.repository.findOne({
    //         where: { indentId: indentDto.indentId },
    //     });
    //     if(!indentEntity) {
    //         throw new ErrorResponse(10000, 'Indent details not found');
    //     } else {
    //         indentEntity.indentDate = indentDto.indentDate;
    //         indentEntity.plantId = indentDto.plantId;
    //         indentEntity.expectedCount = indentDto.expectedCount;
    //         indentEntity.expectedPrice = indentDto.expectedPrice;
    //         indentEntity.expectedQty = indentDto.expectedQty;
    //         indentEntity.farmer = indentDto.farmer;
    //         indentEntity.farmerCode = indentDto.farmerCode;
    //         indentEntity.harvestingDate = indentDto.harvestingDate;
    //         indentEntity.harvestingTime = indentDto.harvestingTime;
    //         indentEntity.product = indentDto.product;
    //         indentEntity.supplierType = indentDto.supplierType;
    //         indentEntity.updatedUser = indentDto.updatedUser;
    //         indentEntity.assignLead1 = indentDto.assignLead1;
    //         indentEntity.assignLead2 = indentDto.assignLead2;
    //         indentEntity.commission = indentDto.commission;
    //         indentEntity.commissionType = indentDto.commissionType;
    //         if(indentDto.broker){
    //             indentEntity.broker = indentDto.broker;
    //         }
    //         const indentResponse = await this.repository.save(indentEntity);            
    //         if (indentResponse) {
    //             return new IndentAckResponse(true, 10000, 'Indent Details Updated Successfully');
    //         }
    //     }
    // }

    /**
     * service to get all the indent records
     * @returns 
     */
    // async getAllIndents(): Promise<AllIndentsResponseModel> {
    //     const manager = getManager()
    //     const indentModelArry: IndentModel[] = [];
    //     // retrieves all plants
    //     // const indentRows: Indent[] = await this.repository.find({
    //     //     order: { harvestingDate: "ASC" },
    //     // });
    //     const indentRows:any =manager.query("select * from "+appSettings.rm_procure_db+".indent where grn_completed=0");
    //     if (indentRows.length === 0) {
    //         throw new ErrorResponse(10000, 'No Records Found');
    //     }
    //     console.log(indentRows.length);
    //     // for (const indentRow of indentRows) {
    //     //     // get master related information in one rest call
    //     //     const masterResponse: MasterInfoFromIndentResponse = await this.supplierService.getMastersRelatedDataFromIndent(new MasterInfoFromIndentRequest(undefined, undefined, undefined, indentRow.assignLead1, indentRow.assignLead2, indentRow.indentBy));
    //     //     const supplierCode = (masterResponse.status) ? masterResponse?.data.supplierCode : '';
    //     //     const supplierName = (masterResponse.status) ? masterResponse?.data.supplierName : '';
    //     //     const farmerName = (masterResponse.status) ? masterResponse?.data.farmerName : '';
    //     //     const farmerCode = (masterResponse.status) ? masterResponse?.data.farmerCode : '';
    //     //     const productCode = (masterResponse.status) ? masterResponse?.data.productCode : '';
    //     //     const leaderName1 = (masterResponse.status) ? masterResponse?.data.leaderName1 : '';
    //     //     const leaderName2 = (masterResponse.status) ? masterResponse?.data.leaderName2 : '';
    //     //     const address = (masterResponse.status) ? masterResponse?.data.address : '';
    //     //     const mobileNumber = (masterResponse.status) ? masterResponse?.data.mobileNumber : '';
    //     //     const indentByName = (masterResponse.status) ? masterResponse?.data.indentByName : '';
    //     //     const getSupplierNameQuery = `SELECT GROUP_CONCAT(farmer) ,s.name as supplier FROM ${appSettings.rm_procure_db}.indent_items i  LEFT JOIN  ${appSettings.masters_db}.suppliers s ON s.supplier_id = i.farmer WHERE indent_id = ${indentRow.indentId}`
    //     //     const supplier = await manager.query(getSupplierNameQuery)

    //     //     indentModelArry.push(new IndentModel(indentRow.plantId, indentRow.indentDate, indentRow.supplierType, undefined, undefined, undefined, undefined, undefined, undefined, indentRow.commissionType, indentRow.commission, indentRow.harvestingDate, indentRow.harvestingTime, indentRow.assignLead1, indentRow.assignLead2, indentRow.indentBy, indentRow.indentId, indentRow.indentCode, indentRow.vehicleAssigned, indentRow.grnCompleted, indentRow.createdUser, indentRow.createdAt, indentRow.updatedUser, indentRow.updatedAt, supplierCode, supplierName, farmerName, farmerCode, productCode, leaderName1, leaderName2, undefined, undefined, undefined, undefined, indentRow.isActive, indentRow.versionFlag, address, mobileNumber, undefined, '', undefined, indentRow.isVehicleRequired, indentRow.harvestType, indentByName, supplier[0]?.supplier ? supplier[0]?.supplier : ''));
    //     // }
    //     const data = new AllIndentsResponseModel(true, 10000, "Indents retrieved successfully", indentRows);
    //     // const newLogDto = new LogsDto(1,'view', 'Indent', 0, true, 'Indents retrieved successfully','','','')
    //     //     let res = await this.logService.createLog(newLogDto);
    //     //     console.log(res);
    //     return data
    // }


    async getIndentReportDetails(req?: IndentReportRequest): Promise<AllIndentReportResponse> {
        try {
            const rmIndentArray: RmIndentReportDto[] = [];
            // retrieves all plants

            // const indentInfo = await this.indentItems.createQueryBuilder("indent_items")
            // .select('count(*) as totalIndents,sum(expected_qty) as totalIndentQty')
            // .leftJoin('indent','indentInfo','indentInfo.indent_id = indent_items.indent_id')
            const indentDetails = this.indentItems.createQueryBuilder('indent_items')
                .select(['indentInfo.indent_code as indentCode,indent_items.product as productId, indentInfo.indent_date as indentDate,indent_items.expected_count as expectedCount,sum(indent_items.expected_qty) as expectedQty,harvesting_date as harvestingDate,expected_price as expectedPrice, GROUP_CONCAT(DISTINCT grn_number,"")  as grnNumber, GROUP_CONCAT(DISTINCT DATE(grn_date),"") as grnDate,grn_completed as grnStatus, sum(grnItems.quantity) as quantity, grnItems.count as count, grnItems.price as price, indentInfo.supplier_type as supplierType'])
                .leftJoin('grn', 'grn', 'grn.indent_no = indent_items.indent_id')
                .leftJoin('grn_items', 'grnItems', 'grnItems.indent_item_id = indent_items.indent_item_id')
                .leftJoin('indent', 'indentInfo', 'indentInfo.indent_id = indent_items.indent_id')


            if (req) {
                if (req.fromDate && req.toDate) {
                    indentDetails.where('Date(indent_date) between "' + req.fromDate.toString() + '" and "' + req.toDate.toString() + '"')
                }
                if (req.indentCode) {
                    indentDetails.andWhere('indent_code="' + req.indentCode + '"')
                }
                if (req.harvestingDate) {
                    indentDetails.andWhere('Date(harvesting_date)="' + req.harvestingDate + '"')
                }
                if (req.supplierType) {
                    indentDetails.andWhere('indents.supplier_type="' + req.supplierType + '"')
                }

            }
            const indent: RmIndentReportDto[] = await indentDetails.groupBy('indent_items.indent_id').getRawMany();

            if (indentDetails) {
                const IndentInfo: RmIndentReportDto[] = []

            }

            for (const indentRow of indent) {

                const productDetails = await this.productRepository.getActiveProductById({ productId: indentRow.productId });
                if (productDetails.status) {
                    const productId = productDetails.status ? productDetails.data.productName : null;
                    indentRow.productCode = productId
                }
                // rmIndentArray.push(new RmIndentReportDto(indentRow.indentCode, indentRow.productCode, indentRow.indentDate, indentRow.harvestingDate, indentRow.grnDate, indentRow.grnNumber, indentRow.grnStatus, indentRow.count, indentRow, indentRow))

            }
            return new AllIndentReportResponse(true, 10000, "Indents retrieved successfully", indent);

        } catch (err) {
            return err;
        }
    }

    async getIndentDataById(req: IndentIdRequest) {
        const manager = getManager();
        // const grnDataByIndentId = `SELECT count(*) FROM `+rmGrnTable+` g where g.indent_no=`+req.indentId;
        // const GrnData = await manager.query(grnDataByIndentId);
        // if(GrnData){
        //     console.log('GrnData')
        //     console.log(GrnData)
        // }else{
        const query = `SELECT i.indent_by as indentBy,memi.employee_name as indentPerson,i.assign_lead_1 as assignLead1,i.supplier_type as supplierType,i.vehicle_assigned as vehicleAssigned,i.is_vehicle_required as isVehicleRequired,i.assign_lead_2 as assignLead12,ii.broker,i.commission,i.commission_type as commissionType,i.created_user as createdUser,i.grn_completed as grnCompleted,i.harvesting_date as harvestingDate,i.harvesting_time as harvestingTime,i.indent_code as indentCode,i.indent_date as indentDate,i.indent_id as indentId,i.plant_id as plantId,ii.product,ii.farmer,ii.expected_count as expectedCount,ii.farmer_code as farmId,ii.indent_item_id as indentItemId,ii.expected_qty as expectedQty,ii.expected_price as expectedPrice,farm.name as farmName,farm.code as farmCode,farm.address as farmAddress,ms.code as farmerCode,msb.code as brokerCode,ms.name as farmerName,ms.contact_number as mobileNumber,ms.street,ms.apartment,ms.city,ms.state,ms.district,ms.postal_code as postalCode,msb.name as brokerName,mp.name as productName,me.employee_name as lead1Name,mem.employee_name as lead2Name, ii.harvest_report_id as harvestReportId, i.harvest_type as harvestType, gi.grn_id as grnId, gi.grn_item_id as grnItemId, gi.count as grnCount, gi.quantity as grnQuantity, gi.actual_count as actualCount, gi.actual_quantity as actualQuantity,d.defect_name as defectName FROM ` + rmIndentTable + ` i 
            LEFT JOIN `+ rmIndentItemsTable + ` ii ON ii.indent_id=i.indent_id 
            LEFT JOIN `+ rmGrnItemsTable + ` gi ON ii.indent_item_id=gi.indent_item_id 
            LEFT JOIN `+ mastersFarmsTable + ` farm ON farm.farm_id=ii.farmer_code 
            LEFT JOIN `+ mastersSuppluierTable + ` ms ON ms.supplier_id=ii.farmer 
            LEFT JOIN `+ mastersSuppluierTable + ` msb ON msb.supplier_id=ii.broker 
            LEFT JOIN `+ mastersProductsTable + ` mp ON mp.product_id=ii.product
            LEFT JOIN `+ mastersEmployeeTable + ` me ON me.employee_id=i.assign_lead_1
            LEFT JOIN `+ mastersEmployeeTable + ` mem ON mem.employee_id=i.assign_lead_2
            LEFT JOIN `+ mastersEmployeeTable + ` memi ON memi.employee_id=i.indent_by
            LEFT JOIN `+ appSettings.rm_procure_db + `.grn_item_defects gid ON gid.indent_id = i.indent_id 
            LEFT JOIN `+ appSettings.masters_db + `.defect d ON d.defect_id = gid.defect_id
            where  i.indent_id=`+ req.indentId;
        const indentData = await manager.query(query);

        // }

        return new CommonResponse(true, 1001, 'Indent data retrieved successfully', indentData);

    }


    /**
     * get dropdown data for indents
     * @returns 
     */
    async getIndentsForDropdown(): Promise<IndentDropdownResponse> {
        const indentsRows = await this.repository.find({
            select: ["indentId", "indentCode"]
        });
        if (indentsRows.length === 0) {
            throw new ErrorResponse(10000, 'No records found');
        }
        const indentDropdownArry: IndentDropdownModel[] = [];
        indentsRows.map(indent => {
            indentDropdownArry.push(new IndentDropdownModel(indent.indentId, indent.indentCode));
        })
        return new IndentDropdownResponse(true, 10000, "Indents retrieved successfully", indentDropdownArry);
    }

    async updateVehicleStatus(updateVehicleStatusRequest: UpdateVehicleStatusRequest): Promise<any> {
        const updateSoStatus = await this.repository.update(
            {
                indentId: Raw(
                    (alias) => `indent_id = '${updateVehicleStatusRequest.indentId}'`
                ),
            },
            { vehicleAssigned: updateVehicleStatusRequest.vehicleAssigned },
        )
        return updateSoStatus.affected;
    }
    /**
   * service to get indent details by indent Id
   * @returns 
   */
    async getIndentDetailsById(indentIdReq: IndentIdRequest): Promise<IndentResponse> {
        const indentRow: Indent = await this.repository.findOne({
            where: { indentId: indentIdReq.indentId }
        });
        if (!indentRow) {
            throw new ErrorResponse(10000, 'No Records Found');
        }

        // get master related information in one rest call
        const masterResponse: MasterInfoFromIndentResponse = await this.supplierService.getMastersRelatedDataFromIndent(new MasterInfoFromIndentRequest(undefined, undefined, undefined, indentRow.assignLead1, indentRow.assignLead2));
        let brokerName = '';
        // if(indentRow.broker){
        //     const brokerResp =  await this.supplierService.getSupplierBySupplierId({farmerId:indentRow.broker});
        //     brokerName = (brokerResp.status)?(brokerResp.data)?brokerResp.data.supplierName:'':'';
        // }

        const indentModelObj = new IndentModel(indentRow.plantId, indentRow.indentDate, indentRow.supplierType, undefined, undefined, undefined, undefined, undefined, undefined, indentRow.commissionType, indentRow.commission, indentRow.harvestingDate, indentRow.harvestingTime, indentRow.assignLead1, indentRow.assignLead2, indentRow.indentId, indentRow.indentBy, indentRow.indentCode, indentRow.vehicleAssigned, indentRow.grnCompleted, indentRow.createdUser, indentRow.createdAt, indentRow.updatedUser, indentRow.updatedAt, masterResponse.data.supplierCode, masterResponse.data.supplierName, masterResponse.data.farmerName, masterResponse.data.farmerCode, masterResponse.data.productCode, masterResponse.data.leaderName1, masterResponse.data.leaderName2, undefined, undefined, undefined, undefined, indentRow.isActive, indentRow.versionFlag, masterResponse.data.address, masterResponse.data.mobileNumber, undefined, brokerName);
        return new IndentResponse(true, 10000, "Indent retrieved successfully", indentModelObj);
    }

    async updateGrnCompletedStatus(grnInfo: GrnStatusUpdate): Promise<GrnCompletedStatusResponse> {
        const updateStatus = await this.repository.update(
            { indentId: Raw((alias) => `indent_id = '${grnInfo.indentId}'`) },
            { grnCompleted: true }
        );
        if (updateStatus) {
            return new GrnCompletedStatusResponse(true, 1111, 'Updated to completed');
        } else {
            throw new ErrorResponse(9999, 'Failed to update');
        }
    }

    async activateOrDeactivateIndent(indentReq: IndentIdRequest): Promise<IndentAckResponse> {
        try {
            const indentExists = await this.getIndentById(indentReq.indentId);
            if (indentExists) {
                if (indentReq.versionFlag !== indentExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the information.Refresh and try again');
                } else {
                    const indentStatus = await this.repository.update(
                        { indentId: indentReq.indentId },
                        { isActive: indentReq.isActive, updatedUser: indentReq.updatedUser });

                    if (indentExists.isActive) {
                        if (indentStatus.affected) {
                            const indentResponse: IndentAckResponse = new IndentAckResponse(true, 10115, 'de-activated successfully');
                            return indentResponse;
                        } else {
                            throw new ErrorResponse(10111, 'already deactivated');
                        }
                    } else {
                        if (indentStatus.affected) {
                            const indentResponse: IndentAckResponse = new IndentAckResponse(true, 10114, 'activated successfully');
                            return indentResponse;
                        } else {
                            throw new ErrorResponse(10112, 'already  activated');
                        }
                    }
                    // }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getIndentById(indentId: number): Promise<Indent> {
        //  console.log(employeeId);
        const Response = await this.repository.findOne({
            where: { indentId: indentId },
        });
        // console.log(employeeResponse);
        if (Response) {
            return Response;
        } else {
            return null;
        }
    }

    async getProductCountWiseIndentQty(inputReq: IndentQuantityRequest): Promise<IndentQtyResponse> {
        const indentData = await this.repository.createQueryBuilder("indent")
            .select('product,expected_count as count,sum(expected_qty) as indentQty')
            .where(`product= ${inputReq.product} and expected_count= ${inputReq.count} and is_active=true`);
        if (!inputReq.toDate) {
            indentData.andWhere(`Date(indent_date) > '${inputReq.fromDate}'`);
        } else if (!inputReq.fromDate) {
            indentData.andWhere(`Date(indent_date) < '${inputReq.toDate}'`)
        }
        else {
            indentData.andWhere(`Date(indent_date) BETWEEN '${inputReq.fromDate}' AND '${inputReq.toDate}'`);
        }

        const indentEntity = await indentData.getRawOne()
        const resdata = new IndentQtyModel(indentEntity.product, indentEntity.count, indentEntity.indentQty)
        if (resdata) {
            return new IndentQtyResponse(true, 99999, 'data retreived', resdata);
        } else {
            return new IndentQtyResponse(false, 1111, 'No records', null);

        }
    }

    async getHarvestinData(plantRequest: PlantRequest): Promise<GetHarvestingResponseModel> {
        // try {
        //     const indentModelArry: HarvestingModelDto[] = [];
        //     // retrieves all plants
        //     let indentRows: Indent[]
        //     if (plantRequest.isPlantHO) {
        //         indentRows = await this.repository.find({
        //             where: { isVehicleRequired: true },
        //             order: { indentId: "ASC" },
        //         });
        //     } else {
        //         indentRows = await this.repository.find({
        //             where: { plantId: plantRequest.plantId },
        //             order: { indentId: "ASC" },
        //         });
        //     }
        //     if (indentRows.length === 0) {
        //         throw new ErrorResponse(10000, 'No Records Found');
        //     }
        //     for (const indentRow of indentRows) {
        //         let vehicleId = 0;
        //         let driverId = 0;
        //         let vehicleName = "";
        //         let driverName = "";
        //         if (indentRow.vehicleAssigned) {
        //             const vehicleAssignmentDetails = await this.vehicleAssignmentService.getVehicleAssignDetailsByIndentId({ indentId: indentRow.indentId });
        //             // console.log(vehicleAssignmentDetails.status);
        //             if (vehicleAssignmentDetails.status) {
        //                 vehicleId = vehicleAssignmentDetails.data.vehicleId === undefined ? 0 : vehicleAssignmentDetails.data.vehicleId;
        //                 driverId = vehicleAssignmentDetails.data.driverId === undefined ? 0 : vehicleAssignmentDetails.data.driverId;
        //                 const driverDetails = await this.employeeService.getActiveEmployeesById({ employeeId: vehicleAssignmentDetails.data.driverId });
        //                 driverName = driverDetails.status ? driverDetails.data.employeeName : "";
        //                 const vehicleDetails = await this.vehicleService.getVehicleByVehId({ vehicleId: vehicleAssignmentDetails.data.vehicleId });
        //                 vehicleName = vehicleDetails.status ? vehicleDetails.data.vehicleName : "";
        //             }
        //         }
        //         const masterResponse: MasterInfoFromIndentResponse = await this.supplierService.getMastersRelatedDataFromIndent(new MasterInfoFromIndentRequest(undefined, undefined, undefined, indentRow.assignLead1, indentRow.assignLead2));

        //         const supplierCode = (masterResponse.status) ? masterResponse.data.supplierCode : '';
        //         const supplierName = (masterResponse.status) ? masterResponse.data.supplierName : '';
        //         const farmerName = (masterResponse.status) ? masterResponse.data.farmerName : '';
        //         const farmerCode = (masterResponse.status) ? masterResponse.data.farmerCode : '';
        //         const productCode = (masterResponse.status) ? masterResponse.data.productCode : '';
        //         const leaderName1 = (masterResponse.status) ? masterResponse.data.leaderName1 : '';
        //         const leaderName2 = (masterResponse.status) ? masterResponse.data.leaderName2 : '';
        //         const address = (masterResponse.status) ? masterResponse.data.address : '';
        //         const mobileNumber = (masterResponse.status) ? masterResponse.data.mobileNumber : '';

        //         indentModelArry.push(new HarvestingModelDto(indentRow.plantId, indentRow.indentDate, indentRow.supplierType, undefined, undefined, undefined, undefined, undefined, undefined, indentRow.commissionType, indentRow.commission, indentRow.harvestingDate, indentRow.harvestingTime, indentRow.assignLead1, indentRow.assignLead2, indentRow.indentBy, driverId, vehicleId, driverName, vehicleName, indentRow.indentId, indentRow.indentCode, indentRow.vehicleAssigned, indentRow.grnCompleted, indentRow.createdUser, indentRow.createdAt, indentRow.updatedUser, indentRow.updatedAt, supplierCode, supplierName, farmerName, farmerCode, productCode, leaderName1, leaderName2, indentRow.isActive, indentRow.versionFlag, address, mobileNumber));
        //     }
        //     const data = new GetHarvestingResponseModel(true, 10000, "Indents retrieved successfully", indentModelArry);
        //     // const newLogDto = new LogsDto(1,'view', 'Indent', 0, true, 'Indents retrieved successfully','','','')
        //     // let res = await this.logService.createLog(newLogDto);
        //     // console.log(res);
        //       return data
        // } catch (err) {
        //     return err;
        // }
        try{
        const manager = getManager();

        var dataQuery = `SELECT Indent.indent_id AS indentId, Indent.indent_code AS indentCode, Indent.indent_date AS indentDate,Indent.supplier_type AS supplierType, Indent.commission_type AS commissionType, Indent.commission AS commission,Indent.harvesting_date AS harvestingDate, Indent.harvesting_time AS harvestingTime, Indent.indent_by AS indentBy,Indent.assign_lead_1 AS assignLead1, Indent.assign_lead_2 AS assignLead2, Indent.vehicle_assigned AS vehicleAssigned,Indent.grn_completed AS grnCompleted, Indent.plant_id AS plantId, Indent.is_vehicle_required AS Indent_is_vehicle_required,Indent.harvest_type AS Indent_harvest_type, Indent.is_active AS isActive, Indent.created_at AS createdAt,Indent.created_user AS createdUser, Indent.updated_at AS updatedAt, Indent.updated_user AS updatedUser,Indent.version_flag AS versionFlag  FROM ` + appSettings.rm_procure_db + `.indent Indent WHERE Indent.is_vehicle_required = 1 ORDER BY Indent.indent_id`;
        const data:HarvestingModelDto[]= await manager.query(dataQuery);
        if (data) {
            return new GetHarvestingResponseModel(true, 116008, " retrieved successfully", data)
          } else {
            return new GetHarvestingResponseModel(true, 116008, "Something went wrong")
          }
        }catch (error) {
            return error
        }
    }
    
    async cancelAssignedVehicle(indentReq: IndentModel): Promise<CommonResponse> {
        try {
            const indentDetails = await this.repository.find({ where: { indentId: indentReq.indentId } });
            if (indentDetails) {
                const response = await this.repository.update({ indentId: indentReq.indentId }, {
                    vehicleAssigned: false,
                })
                return new CommonResponse(true, 1000, "Vehicle cancelled for Indent harvesting", response.affected);
            }
            else {
                return new CommonResponse(true, 1001, "something went wrong");
            }

        } catch (err) {
            return err;
        }
    }

    async getIndentQty(): Promise<IndentQtyResponse> {
        const indentInfo = await this.indentItems.createQueryBuilder("indent_items")
            .select('count(*) as totalIndents,sum(expected_qty) as totalIndentQty')
            .leftJoin('indent', 'indentInfo', 'indentInfo.indent_id = indent_items.indent_id')
            .where(`indentInfo.is_active=true`)
            // .groupBy('indent.indent_id')
            .getRawOne()

        if (indentInfo) {
            const indentQtyModel = new IndentQtyModel(undefined, undefined, indentInfo.totalIndentQty, indentInfo.totalIndents)
            return new IndentQtyResponse(true, 55555, 'Indent qty retrived', indentQtyModel);
        } else {
            return new IndentQtyResponse(false, 9999, 'NO data', undefined);
        }
    }

    async getPendingGrnQty(): Promise<IndentQtyResponse> {
        const indentInfo = await this.indentItems.createQueryBuilder("indent_items")
            .leftJoin('indent', 'indentInfo', 'indentInfo.indentId = indent_items.indent_id')
            .select('sum(indent_items.expected_qty) as GrnPendingQty')
            .where(`indent_items.is_active=true`)
            .andWhere(`grn_completed=false`)
            .getRawOne()

        if (indentInfo) {
            const indentQtyModel = new IndentQtyModel(undefined, undefined, indentInfo.GrnPendingQty)
            return new IndentQtyResponse(true, 55555, 'Indent qty retrived', indentQtyModel);
        } else {
            return new IndentQtyResponse(false, 9999, 'NO data', undefined);
        }
    }

    /**
     * saves harvest report data for ident id
     * @param harvestDto 
     * @returns 
     */
    async createHarvestReport(harvestDto: HarvestDto): Promise<HarvestReportResponse> {
        const harvestEnt = new HaverstReport();
        harvestEnt.plantId = harvestDto.plantId;
        harvestEnt.harvestDate = harvestDto.harvestDate;
        harvestEnt.farmerData = harvestDto.farmerData;
        harvestEnt.harvestTime = harvestDto.harvestTime;
        harvestEnt.product = harvestDto.product;
        harvestEnt.quantity = harvestDto.quantity;
        harvestEnt.temperature1 = harvestDto.temperature1;
        harvestEnt.temperature2 = harvestDto.temperature2;
        harvestEnt.temperature3 = harvestDto.temperature3;
        harvestEnt.temperature4 = harvestDto.temperature4;
        harvestEnt.temperature5 = harvestDto.temperature5;
        harvestEnt.properIcing = harvestDto.properIcing;
        harvestEnt.chillKilled = harvestDto.chillKilled;
        harvestEnt.cleanBoxes = harvestDto.cleanBoxes;
        harvestEnt.createdUser = harvestDto.createdUser;
        harvestEnt.driverName = harvestDto.driverName;
        harvestEnt.healthyShrimps = harvestDto.healthyShirmps;
        harvestEnt.hygineHandle = harvestDto.hygineHandle;
        harvestEnt.indentId = harvestDto.indentId;
        harvestEnt.indentItemId = harvestDto.indentItemId;
        harvestEnt.vehicleLeavingTime = harvestDto.vehicleLeavingTime;
        harvestEnt.vehicleNo = harvestDto.vehicleNo;
        harvestEnt.remarks = harvestDto.remarks;
        harvestEnt.sealNo = harvestDto.sealNo
        const harvestData = await this.harvestEntity.save(harvestEnt);
        await this.indentItems.update({ indentItemId: harvestDto.indentItemId }, { harvestReportId: harvestData.harvestReportId });
        return new HarvestReportResponse(true, 10000, 'Harvest data retrieved successfully', new HarvestModel(harvestData.plantId, harvestData.harvestDate, harvestData.farmerData, harvestData.harvestTime, harvestData.product, harvestData.quantity, harvestData.temperature1, harvestData.temperature2, harvestData.temperature3, harvestData.temperature4, harvestData.temperature5, harvestData.cleanBoxes, harvestData.hygineHandle, harvestData.healthyShrimps, harvestData.chillKilled, harvestData.properIcing, harvestData.vehicleNo, harvestData.driverName, harvestData.vehicleLeavingTime, harvestData.indentId, harvestData.createdUser, harvestData.remarks, harvestData.sealNo, harvestData.indentItemId));

    }
    /**
     * getting harvest report data for a havest id and plant id
     * @param harvestIdRequest 
     * @returns 
     */
    async getHarvestReport(harvestIdRequest: HarvestIdRequest): Promise<HarvestReportResponse> {
        const harvestData = await this.harvestEntity.findOne({ where: { harvestReportId: harvestIdRequest.harvestId } });
        if (!harvestData) {
            throw new ErrorResponse(10000, 'Harvest report data not found');
        }
        return new HarvestReportResponse(true, 10000, 'Harvest data retrieved successfully', new HarvestModel(harvestData.plantId, harvestData.harvestDate, harvestData.farmerData, harvestData.harvestTime, harvestData.product, harvestData.quantity, harvestData.temperature1, harvestData.temperature2, harvestData.temperature3, harvestData.temperature4, harvestData.temperature5, harvestData.cleanBoxes, harvestData.hygineHandle, harvestData.healthyShrimps, harvestData.chillKilled, harvestData.properIcing, harvestData.vehicleNo, harvestData.driverName, harvestData.vehicleLeavingTime, harvestData.indentId, harvestData.createdUser, harvestData.remarks, harvestData.sealNo, harvestData.indentItemId));
    }

    async openOrCloseGrn(indentRequest: IndentIdRequest): Promise<CommonResponse> {
        const manager = new GenericTransactionManager()
        try {
            manager.startTransaction()
            const updateGrnStatus = await this.repository.update(
                {
                    indentId: Raw(
                        (alias) => `indent_id = '${indentRequest.indentId}'`
                    ),
                },
                { grnCompleted: indentRequest.grnCompleted },
            )
            if (updateGrnStatus.affected) {
                manager.completeTransaction();
                return new CommonResponse(true, 1, 'updated', undefined)
            } else {
                manager.releaseTransaction();
                return new CommonResponse(false, 0, 'updation failed', undefined)
            }
        } catch (err) {
            manager.releaseTransaction();
            return err
        }
        return
    }

    async getClosedIndents(): Promise<AllIndentsResponseModel> {
        const manager = getManager();
        let indentData;
        const query = `SELECT i.indent_by as indentBy,memi.employee_name as indentPerson,i.assign_lead_1 as assignLead1,i.supplier_type as supplierType,i.vehicle_assigned as vehicleAssigned,i.is_vehicle_required as isVehicleRequired,i.assign_lead_2 as assignLead12,ii.broker,i.commission,i.commission_type as commissionType,i.created_user as createdUser,i.grn_completed as grnCompleted,i.harvesting_date as harvestingDate,i.harvesting_time as harvestingTime,i.indent_code as indentCode,i.indent_date as indentDate,i.indent_id as indentId,i.plant_id as plantId,ii.product,ii.farmer,ii.expected_count as expectedCount,ii.farmer_code as farmId,ii.indent_item_id as indentItemId,ii.expected_qty as expectedQty,ii.expected_price as expectedPrice,farm.name as farmName,farm.code as farmCode,farm.address as farmAddress,ms.code as farmerCode,msb.code as brokerCode,ms.name as farmerName,ms.contact_number as mobileNumber,ms.street,ms.apartment,ms.city,ms.state,ms.district,ms.postal_code as postalCode,msb.name as brokerName,mp.name as productName,me.employee_name as lead1Name,mem.employee_name as lead2Name, ii.harvest_report_id as harvestReportId,i.is_active as isActive,i.plant_id AS plantId,uc.unit_name AS plant FROM ` + rmIndentTable + ` i
            LEFT JOIN `+ rmIndentItemsTable + ` ii ON ii.indent_id=i.indent_id 
            LEFT JOIN `+ mastersFarmsTable + ` farm ON farm.farm_id=ii.farmer_code 
            LEFT JOIN `+ mastersSuppluierTable + ` ms ON ms.supplier_id=ii.farmer 
            LEFT JOIN `+ mastersSuppluierTable + ` msb ON msb.supplier_id=ii.broker 
            LEFT JOIN `+ mastersProductsTable + ` mp ON mp.product_id=ii.product
            LEFT JOIN `+ mastersEmployeeTable + ` me ON me.employee_id=i.assign_lead_1
            LEFT JOIN `+ mastersEmployeeTable + ` mem ON mem.employee_id=i.assign_lead_2
            LEFT JOIN `+ masterUnit + ` uc ON uc.unit_code_id = i.plant_id
            LEFT JOIN `+ mastersEmployeeTable + ` memi ON memi.employee_id=i.indent_by where i.grn_completed=` + true + ` group by i.indent_id`;
        indentData = await manager.query(query);
        return new AllIndentsResponseModel(true, 5555, 'closed indents retrived', indentData)
    }

    async getAllIndents(): Promise<AllIndentsResponseModel> {
        const manager = getManager()
        const query = ` SELECT i.indent_by AS indentBy,memi.employee_name AS indentByName,i.assign_lead_1 AS assignLead1,i.supplier_type AS supplierType,i.vehicle_assigned AS vehicleAssigned,i.is_vehicle_required AS isVehicleRequired,i.assign_lead_2 AS assignLead12,ii.broker,i.commission,i.commission_type AS commissionType,i.created_user AS createdUser,i.grn_completed AS grnCompleted,i.harvesting_date AS harvestingDate,i.harvesting_time AS harvestingTime,i.harvest_type AS harvestType,i.indent_code AS indentCode,i.indent_date AS indentDate,i.indent_id AS indentId,i.plant_id AS plantId,ii.product,ii.farmer,GROUP_CONCAT(ii.expected_count) AS expectedCount,ii.farmer_code AS farmId,ii.indent_item_id AS indentItemId,ii.expected_qty AS expectedQty,ii.expected_price AS expectedPrice,farm.name AS farmName,farm.code AS farmCode,farm.address AS farmAddress,ms.code AS farmerCode,msb.code AS brokerCode,ms.name AS supplier,ms.contact_number AS mobileNumber,ms.street,ms.apartment,ms.city,ms.state,ms.district,ms.postal_code AS postalCode,msb.name AS brokerName,mp.name AS productName,me.employee_name AS lead1Name,mem.employee_name AS lead2Name, ii.harvest_report_id AS harvestReportId,i.is_active as isActive,uc.unit_name AS plant FROM ` + rmIndentTable + ` i
          LEFT JOIN `+ rmIndentItemsTable + ` ii ON ii.indent_id=i.indent_id 
          LEFT JOIN `+ mastersFarmsTable + ` farm ON farm.farm_id=ii.farmer_code 
          LEFT JOIN `+ mastersSuppluierTable + ` ms ON ms.supplier_id=ii.farmer 
          LEFT JOIN `+ mastersSuppluierTable + ` msb ON msb.supplier_id=ii.broker 
          LEFT JOIN `+ mastersProductsTable + ` mp ON mp.product_id=ii.product
          LEFT JOIN `+ mastersEmployeeTable + ` me ON me.employee_id=i.assign_lead_1
          LEFT JOIN `+ mastersEmployeeTable + ` mem ON mem.employee_id=i.assign_lead_2
          LEFT JOIN `+ masterUnit + ` uc ON uc.unit_code_id = i.plant_id
          LEFT JOIN `+ mastersEmployeeTable + ` memi ON memi.employee_id=i.indent_by where i.grn_completed=0 group by i.indent_id `;
        const indentData = await manager.query(query);
        console.log('indentData.length');
        console.log(indentData.length);
        if (indentData.length > 0) {
            return new AllIndentsResponseModel(true, 5555, 'indents retrived', indentData)
        } else {
            return new AllIndentsResponseModel(true, 5555, 'No data found')
        }
    }
    async getIndentAbstract(indentAbstractRequest: IndentAbstractRequest): Promise<any> {
        // console.log(new Date(indentAbstractRequest.fromDate));
        const manager = getManager();
        const query = `SELECT indent_by,e.employee_name as indentBy,indent_date AS indentDate,
        SUM(CASE WHEN expected_count BETWEEN 0 AND 25 THEN expected_qty ELSE 0 END) AS count25,
        SUM(CASE WHEN expected_count BETWEEN 0 AND 32 THEN expected_qty ELSE 0 END) AS count30,
        SUM(CASE WHEN expected_count BETWEEN 0 AND 42 THEN expected_qty ELSE 0 END) AS count40,
        SUM(CASE WHEN expected_count BETWEEN 0 AND 52 THEN expected_qty ELSE 0 END) AS count50,
        SUM(CASE WHEN expected_count BETWEEN 0 AND 62 THEN expected_qty ELSE 0 END) AS count60,
        SUM(CASE WHEN expected_count BETWEEN 0 AND 72 THEN expected_qty ELSE 0 END) AS count70,
        SUM(CASE WHEN expected_count BETWEEN 0 AND 82 THEN expected_qty ELSE 0 END) AS count80,
        SUM(CASE WHEN expected_count BETWEEN 0 AND 92 THEN expected_qty ELSE 0 END) AS count90,
        SUM(CASE WHEN expected_count BETWEEN 0 AND 102 THEN expected_qty ELSE 0 END) AS count100,
        SUM(CASE WHEN expected_count BETWEEN 0 AND 112 THEN expected_qty ELSE 0 END) AS count110,
        SUM(CASE WHEN expected_count BETWEEN 0 AND 122 THEN expected_qty ELSE 0 END) AS count120,
        SUM(CASE WHEN expected_count BETWEEN 0 AND 132 THEN expected_qty ELSE 0 END) AS count130,
        SUM(CASE WHEN expected_count BETWEEN 0 AND 500 THEN expected_qty ELSE 0 END) AS count140
        FROM indent_items LEFT JOIN indent i ON i.indent_id=indent_items.indent_id left join `+ appSettings.masters_db + `.employee_details e on e.employee_id=i.indent_by
        WHERE (DATE(indent_date)between date('`+ indentAbstractRequest.fromDate + `') and date('` + indentAbstractRequest.toDate + `'))
        GROUP BY indent_by`;
        // console.log(query);
        let indentAbstract = await manager.query(query);
        return new AllIndentsResponseModel(true, 5555, 'closed indents retrived', indentAbstract)
    }
    @Cron('0 8 * * *')
    async getRMUsageReport(): Promise<CommonResponse> {
        const manager = getManager()
        const datetime = moment().subtract(1, "days").format('MMMM Do, YYYY')

        const indentsCount = `SELECT created_at,SUM(IF(plant_id = 1,1,0))AS kkd,SUM(IF(plant_id = 0,1,0))AS plantnotassigned,SUM(IF(plant_id = 2,1,0))AS unit1,SUM(IF(plant_id = 3,1,0))AS unit2
        FROM ${appSettings.rm_procure_db}.indent WHERE is_active = 1 AND DATE(created_at)=DATE_SUB(CURDATE(), INTERVAL 1 DAY)`;
        const indentData = await manager.query(indentsCount)
        const grnCount = `SELECT created_at,SUM(IF(plant_id = 1,1,0))AS kkd,SUM(IF(plant_id = 2,1,0))AS unit1,SUM(IF(plant_id = 3,1,0))AS unit2
        FROM ${appSettings.rm_procure_db}.grn WHERE is_active = 1 AND DATE(created_at)=DATE_SUB(CURDATE(), INTERVAL 1 DAY)`;
        const grnData = await manager.query(grnCount)
        const vehicleassignedIndents = `SELECT created_at,SUM(IF(plant_id = 1,1,0))AS kkd,SUM(IF(plant_id = 2,1,0))AS unit1,SUM(IF(plant_id = 3,1,0))AS unit2
        FROM ${appSettings.rm_procure_db}.indent WHERE is_active = 1 and vehicle_assigned = 1 AND DATE(created_at)=DATE_SUB(CURDATE(), INTERVAL 1 DAY)`;
        const VehicleAssignedIndentdata = await manager.query(vehicleassignedIndents)
        const indentmesStr = (" \\n " + 'unit1:' + (indentData[0].unit1 > 0 ? indentData[0].unit1 : 0) + " \\n " + 'unit2:' + (indentData[0].unit2 > 0 ? indentData[0].unit2 : 0) + "  \\n " + 'unit3:' + (indentData[0].kkd > 0 ? indentData[0].kkd : 0) + "  \\n " + 'Plant not assigned:' + (indentData[0].plantnotassigned > 0 ? indentData[0].plantnotassigned : 0)) + "\\n "
        const grnmesStr = (" \\n " + 'unit1:' + (grnData[0].unit1 ? grnData[0].unit1 : 0) + " \\n " + 'unit2:' + (grnData[0].unit2 ? grnData[0].unit2 : 0) + "  \\n " + 'unit3:' + (grnData[0].kkd ? grnData[0].kkd : 0) + "  \\n ") + "\\n "
        const vehicleassignedindentmesStr = (" \\n " + 'unit1:' + (VehicleAssignedIndentdata[0].unit1 ? VehicleAssignedIndentdata[0].unit1 : 0) + " \\n " + 'unit2:' + (VehicleAssignedIndentdata[0].unit2 ? VehicleAssignedIndentdata[0].unit2 : 0) + "  \\n " + 'unit3:' + (VehicleAssignedIndentdata[0].kkd ? VehicleAssignedIndentdata[0].kkd : 0) + "  \\n ") + "\\n "
        const parameters = [
            { "type": "text", "text": indentmesStr },
            { "type": "text", "text": grnmesStr },
            // { "type": "text", "text": vehicleassignedindentmesStr},
            { "type": "text", "text": datetime },
        ];
        const contacts = whatsApp.contacts;
        let statusFlag
        for (const contact of contacts) {

            const req = await new MessageParameters(contact, 'rm_usage_report', parameters, 'en_us')
            const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
            if (!messageStatus.status) {
                statusFlag = false
                break
            } else {
                statusFlag = true
                // const whatsapplogDto = new WhatsAppLogDto(contact,'rm_usage_report','Sandhya',GlobalVariableValues.companyId,GlobalVariableValues.rmProcurementmoduleId)
                // await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
               
            }
        }
        if (statusFlag) {
            return new CommonResponse(true, 4444, 'message sent')
        } else {
            return new CommonResponse(false, 4444, 'message not sent')
        }
    }
}
